import React, { Component } from "react";
import PrincipalEdit from "../../components/PrincipalEdit/PrincipalEdit";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import ImageUploader from "../ImageUploader/ImageUploader";
import MenuItem from "@material-ui/core/MenuItem";

const style = {
	display: "grid",
	gridTemplateColumns: "repeat(1,1fr)",
	gridGap: "10px",
	gridAutoRows: "minmax(100px,auto)"
};

const secciones = [
	{
		value: "Geo",
		label: "Mapa"
	},
	{
		value: "Activity",
		label: "Actividades"
	},
	{
		value: "Information",
		label: "Información"
	},
	{
		value: "Promociones",
		label: "Promociones"
	},
	{
		value: "Favourites",
		label: "Favoritos"
	},
	{
		value: "DesignVillage",
		label: "Design Village"
	},
	,
	{
		value: "SolanasKids",
		label: "Solanas Kids"
	},
	{
		value: "CrystalBeach",
		label: "Crystal Beach"
	},
	{
		value: "GardensView",
		label: "Gardens View"
	},
	{
		value: "GreenPark",
		label: "Green Park"
	},
	{
		value: "ConventionCenter",
		label: "Convention Center"
	},
	{
		value: "CrystalView",
		label: "Crystal View"
	}
];

class Principal extends Component {
	state = {
		createNew: false,
		title: "",
		info: "",
		fieldValues: {
			image: ""
		}
	};
	componentDidMount() {}

	handleCreatePrincipal = () => {
		this.setState({
			createNew: true
		});
	};

	handleCancel = () => {
		this.setState({
			createNew: false
		});
	};

	handleConfirm = () => {
		if (this.state.title && this.state.info) {
			this.props.handleCreate(
				{
					titulo: this.state.title,
					descripcion: this.state.info,
					seccion: this.state.seccion,
					image: this.state.fieldValues.image
				},
				this.props.token
			);
			this.setState({
				error: false,
				createNew: false,
				titulo: "",
				descripcion: "",
				seccion: "",
				image: ""
			});
		} else {
			this.setState({ error: true });
		}
	};

	render() {
		return (
			<div>
				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.createNew}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "20% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Crear Nuevo Item Principal
							<br />
							<br />
							<br />
							<TextField
								id="outlined-basic"
								label="Titulo"
								variant="outlined"
								value={this.state.title}
								onChange={value => this.setState({ title: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<br />
							<TextField
								id="outlined-basic"
								label="Descripción"
								variant="outlined"
								multiline
								value={this.state.info}
								onChange={value => this.setState({ info: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="standard-select"
								select
								label="Sección"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.seccion}
								onChange={value =>
									this.setState({ seccion: value.target.value })
								}
							>
								{secciones.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<br />
							<ImageUploader fieldValues={this.state.fieldValues} />
							{this.state.error ? (
								<div>* Complete todos los campos </div>
							) : null}
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button onClick={this.handleCancel} color="primary">
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>
				<h2 style={{ width: "100%", textAlign: "left" }}>Pantalla Principal</h2>
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.handleCreatePrincipal}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#00adee" }}
					>
						Agregar Item
					</Button>
				</div>
				<div style={style}>
					{this.props.principal.map(l => (
						<PrincipalEdit
							id={l.idPantallaPrincipal}
							titulo={l.titulo}
							descripcion={l.descripcion}
							seccion={l.seccion}
							imagen={l.imagen}
							handleSave={this.props.handleSave}
							token={this.props.token}
							handleDelete={this.props.handleDelete}
						/>
					))}
				</div>
			</div>
		);
	}
}

export default Principal;
